var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecureloginBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.56,211.48s-61.1-149-172.8-177.82S122.21,92.88,105.1,153.92,24.91,295.76,30.63,351.27C36.08,404,82.31,429,125.49,439.68c54.88,13.61,117.25,14.64,172.34,3.3a358.52,358.52,0,0,0,38.73-10.49c25.88-8.44,51.29-15,77.5-22,49.88-13.3,69.64-66.87,64-118.13C474.9,263.54,464.33,237.73,453.56,211.48Z",
    style: {
      fill: "#30D6BE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.56,211.48s-61.1-149-172.8-177.82S122.21,92.88,105.1,153.92,24.91,295.76,30.63,351.27C36.08,404,82.31,429,125.49,439.68c54.88,13.61,117.25,14.64,172.34,3.3a358.52,358.52,0,0,0,38.73-10.49c25.88-8.44,51.29-15,77.5-22,49.88-13.3,69.64-66.87,64-118.13C474.9,263.54,464.33,237.73,453.56,211.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-22"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 48.65,
    y1: 220.72,
    x2: 67.1,
    y2: 397.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.12,
    y1: 363.63,
    x2: 55.76,
    y2: 354.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,357.45A9.45,9.45,0,0,0,55,350.36c-2.14-1.92-13.44-6.67-14.51-2.69C39.29,352,50.86,360.49,58.3,357.45Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.3,
    y1: 357.45,
    x2: 47.55,
    y2: 350.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.22,
    y1: 383.73,
    x2: 57.86,
    y2: 374.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4,377.55a9.45,9.45,0,0,0-3.33-7.09c-2.14-1.92-13.44-6.67-14.51-2.69C41.39,372.09,53,380.59,60.4,377.55Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.4,
    y1: 377.55,
    x2: 49.65,
    y2: 370.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 314.59,
    x2: 50.64,
    y2: 305.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.18,308.4a9.47,9.47,0,0,0-3.32-7.09c-2.15-1.92-13.45-6.67-14.52-2.69C34.18,303,45.74,311.44,53.18,308.4Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.18,
    y1: 308.4,
    x2: 42.43,
    y2: 301.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.1,
    y1: 334.69,
    x2: 52.74,
    y2: 325.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.28,328.5A9.46,9.46,0,0,0,52,321.41c-2.14-1.92-13.44-6.67-14.51-2.69C36.27,323.05,47.83,331.54,55.28,328.5Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.28,
    y1: 328.5,
    x2: 44.53,
    y2: 321.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.6,
    y1: 281.94,
    x2: 47.24,
    y2: 273.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.78,275.75a9.5,9.5,0,0,0-3.33-7.09C44.3,266.74,33,262,31.93,266,30.77,270.3,42.33,278.79,49.78,275.75Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.78,
    y1: 275.75,
    x2: 39.02,
    y2: 269.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.17,
    y1: 249.14,
    x2: 43.81,
    y2: 240.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35,243A9.46,9.46,0,0,0,43,235.87c-2.15-1.92-13.45-6.67-14.52-2.69C27.35,237.5,38.91,246,46.35,243Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.35,
    y1: 242.96,
    x2: 35.6,
    y2: 236.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.72,
    y1: 351.74,
    x2: 69.08,
    y2: 341.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.14,344.49a9.48,9.48,0,0,1,1.79-7.63c1.7-2.32,11.77-9.3,13.64-5.63C84.61,335.22,75.05,345.93,67.14,344.49Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.14,
    y1: 344.49,
    x2: 76.82,
    y2: 335.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.2,
    y1: 298.85,
    x2: 63.56,
    y2: 288.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.62,291.6A9.48,9.48,0,0,1,63.41,284c1.7-2.32,11.77-9.3,13.64-5.63C79.09,282.33,69.53,293,61.62,291.6Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.62,
    y1: 291.6,
    x2: 71.3,
    y2: 282.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.77,
    y1: 275.6,
    x2: 61.13,
    y2: 265.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,268.35A9.48,9.48,0,0,1,61,260.72c1.71-2.31,11.78-9.3,13.65-5.63C76.66,259.09,67.1,269.79,59.19,268.35Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.19,
    y1: 268.35,
    x2: 68.87,
    y2: 259.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.22,
    y1: 241.53,
    x2: 57.57,
    y2: 231.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.63,234.27a9.44,9.44,0,0,1,1.8-7.62c1.7-2.32,11.77-9.3,13.64-5.63C73.1,225,63.55,235.71,55.63,234.27Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.63,
    y1: 234.27,
    x2: 65.32,
    y2: 225.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,219.74a9.48,9.48,0,0,1,1.79-7.63c1.7-2.31,11.77-9.3,13.64-5.62C66,210.48,56.41,221.18,48.5,219.74Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: 219.74,
    x2: 58.18,
    y2: 210.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.06,220.14a9.48,9.48,0,0,1-7.4-2.58c-2.13-1.94-8-12.69-4.17-14.16C41.68,201.79,51.32,212.42,49.06,220.14Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.06,
    y1: 220.14,
    x2: 40.87,
    y2: 209.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3,
    y1: 245.06,
    x2: 78.96,
    y2: 421.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.01,
    y1: 388.1,
    x2: 76.65,
    y2: 377.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,380.85a9.46,9.46,0,0,0-1.8-7.63c-1.7-2.32-11.78-9.29-13.64-5.62C61.11,371.59,70.68,382.29,78.59,380.85Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.59,
    y1: 380.85,
    x2: 69.45,
    y2: 372.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.1,
    y1: 339.05,
    x2: 81.74,
    y2: 328.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,331.8a9.46,9.46,0,0,0-1.8-7.63c-1.7-2.32-11.78-9.29-13.64-5.62C66.2,322.54,75.77,333.24,83.68,331.8Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.68,
    y1: 331.8,
    x2: 74.54,
    y2: 323.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.02,
    y1: 359.15,
    x2: 79.65,
    y2: 348.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.59,351.9a9.48,9.48,0,0,0-1.79-7.63C78.09,342,68,335,66.15,338.65,64.12,342.64,73.68,353.34,81.59,351.9Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.59,
    y1: 351.9,
    x2: 72.45,
    y2: 343.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.49,
    y1: 306.39,
    x2: 85.13,
    y2: 296.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,299.14a9.44,9.44,0,0,0-1.8-7.62c-1.7-2.32-11.78-9.3-13.65-5.62C69.59,289.89,79.16,300.59,87.07,299.14Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.07,
    y1: 299.14,
    x2: 77.93,
    y2: 290.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.89,
    y1: 273.6,
    x2: 88.53,
    y2: 263.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,266.35a9.48,9.48,0,0,0-1.79-7.63C87,256.4,76.89,249.43,75,253.1,73,257.09,82.56,267.79,90.47,266.35Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.47,
    y1: 266.35,
    x2: 81.33,
    y2: 257.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.09,
    y1: 376.17,
    x2: 92.44,
    y2: 367.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,370a9.45,9.45,0,0,1,3.33-7.09c2.14-1.92,13.44-6.68,14.51-2.7C108.91,364.51,97.35,373,89.9,370Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.9,
    y1: 369.98,
    x2: 101.29,
    y2: 362.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.58,
    y1: 323.27,
    x2: 97.93,
    y2: 314.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.39,317.09a9.48,9.48,0,0,1,3.33-7.1c2.14-1.92,13.43-6.68,14.51-2.7C114.4,311.62,102.84,320.12,95.39,317.09Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.39,
    y1: 317.09,
    x2: 106.77,
    y2: 310.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.99,
    y1: 300.03,
    x2: 100.34,
    y2: 291.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81,293.84a9.42,9.42,0,0,1,3.32-7.09c2.14-1.92,13.44-6.68,14.51-2.7C116.81,288.37,105.25,296.88,97.81,293.84Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.81,
    y1: 293.84,
    x2: 109.19,
    y2: 286.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.52,
    y1: 265.95,
    x2: 103.88,
    y2: 257.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34,259.76a9.45,9.45,0,0,1,3.33-7.09c2.14-1.92,13.43-6.68,14.51-2.7C120.35,254.29,108.79,262.8,101.34,259.76Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.34,
    y1: 259.76,
    x2: 112.72,
    y2: 252.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.35,244.07a9.46,9.46,0,0,1,3.32-7.09c2.15-1.92,13.44-6.68,14.51-2.7C116.35,238.6,104.8,247.11,97.35,244.07Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.35,
    y1: 244.07,
    x2: 108.73,
    y2: 237.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.82,244.58a9.48,9.48,0,0,1-6.71-4.05c-1.68-2.34-5.23-14.07-1.16-14.72C94.37,225.1,101.62,237.49,97.82,244.58Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.82,
    y1: 244.58,
    x2: 91.99,
    y2: 232.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.28,
    y1: 173.09,
    x2: 76.28,
    y2: 396.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.46,
    y1: 362.99,
    x2: 69.06,
    y2: 353.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,356.23a9.45,9.45,0,0,0-2.57-7.4c-1.94-2.12-12.68-8-14.16-4.18C53,348.83,63.59,358.49,71.31,356.23Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.31,
    y1: 356.23,
    x2: 61.31,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.46,
    y1: 320.99,
    x2: 69.06,
    y2: 311.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,314.23a9.45,9.45,0,0,0-2.57-7.4c-1.94-2.13-12.68-8-14.16-4.18C53,306.83,63.59,316.48,71.31,314.23Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.31,
    y1: 314.23,
    x2: 61.31,
    y2: 306.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.46,
    y1: 271.67,
    x2: 69.06,
    y2: 262.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,264.92a9.45,9.45,0,0,0-2.57-7.4c-1.94-2.13-12.68-8-14.16-4.18C53,257.52,63.59,267.17,71.31,264.92Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.31,
    y1: 264.92,
    x2: 61.31,
    y2: 257.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.46,
    y1: 238.85,
    x2: 69.06,
    y2: 229.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,232.09a9.45,9.45,0,0,0-2.57-7.4c-1.94-2.13-12.68-8-14.16-4.18C53,224.69,63.59,234.34,71.31,232.09Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.31,
    y1: 232.09,
    x2: 61.31,
    y2: 224.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.46,
    y1: 205.88,
    x2: 69.06,
    y2: 196.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,199.12a9.45,9.45,0,0,0-2.57-7.4c-1.94-2.13-12.68-8-14.16-4.18C53,191.72,63.59,201.37,71.31,199.12Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.31,
    y1: 199.12,
    x2: 61.31,
    y2: 191.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.3,
    y1: 375.82,
    x2: 83.7,
    y2: 366.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,369.06a9.48,9.48,0,0,1,2.58-7.4c1.93-2.13,12.67-8,14.15-4.18C99.78,361.66,89.16,371.31,81.44,369.06Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.44,
    y1: 369.06,
    x2: 92.03,
    y2: 360.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.3,
    y1: 309.01,
    x2: 83.7,
    y2: 299.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,302.26a9.48,9.48,0,0,1,2.58-7.4c1.93-2.13,12.67-8,14.15-4.18C99.78,294.86,89.16,304.51,81.44,302.26Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.44,
    y1: 302.26,
    x2: 92.03,
    y2: 294.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.3,
    y1: 276.04,
    x2: 83.7,
    y2: 266.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,269.29a9.48,9.48,0,0,1,2.58-7.4c1.93-2.13,12.67-8,14.15-4.19C99.78,261.89,89.16,271.54,81.44,269.29Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.44,
    y1: 269.29,
    x2: 92.03,
    y2: 261.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.3,
    y1: 232.46,
    x2: 83.7,
    y2: 222.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,225.71a9.48,9.48,0,0,1,2.58-7.4c1.93-2.13,12.67-8,14.15-4.19C99.78,218.31,89.16,228,81.44,225.71Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.44,
    y1: 225.71,
    x2: 92.03,
    y2: 217.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.3,
    y1: 198.2,
    x2: 83.7,
    y2: 188.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,191.45a9.47,9.47,0,0,1,2.58-7.4c1.93-2.13,12.67-8,14.15-4.19C99.78,184.05,89.16,193.7,81.44,191.45Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.44,
    y1: 191.45,
    x2: 92.03,
    y2: 183.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,176.25a9.48,9.48,0,0,1,2.58-7.4c1.93-2.13,12.67-8,14.15-4.18C94.19,168.85,83.57,178.5,75.85,176.25Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.85,
    y1: 176.25,
    x2: 86.44,
    y2: 168.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,176.71a9.48,9.48,0,0,1-7.09-3.34c-1.91-2.15-6.65-13.45-2.67-14.52C70.93,157.69,79.42,169.26,76.37,176.71Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.37,
    y1: 176.71,
    x2: 69.33,
    y2: 165.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.48 454.56 61.81 454.56 58.85 394.79 88.44 394.79 85.48 454.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.34,315.42a13.23,13.23,0,0,1,1.51-5.53c1.38-2.27,6.41-3.9,9.06-2.77a35.14,35.14,0,0,1,3.9,1.89,29.77,29.77,0,0,0-7.43,3.52A18.59,18.59,0,0,1,379.34,315.42Z",
    style: {
      fill: "#30D6BE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,317.06a13,13,0,0,0,3.53-6.92c.5-4-3.78,1.68-3.78,1.68s-2.14-8.1-3.39-3.57S374.05,317.06,374.05,317.06Z",
    style: {
      fill: "#30D6BE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.27,315.8s.75-3.77-.63-6.41-5-2.39-8.68-1.26a20.55,20.55,0,0,1-4.78,1.13,54.18,54.18,0,0,0,7.92,4.4A49.08,49.08,0,0,0,368.27,315.8Z",
    style: {
      fill: "#30D6BE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,329.36a.33.33,0,0,0,.33-.33V311a.32.32,0,0,0-.33-.32.32.32,0,0,0-.32.32v18A.32.32,0,0,0,374,329.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.51,329.36h.05a.33.33,0,0,0,.27-.37c-.06-.45-1.58-11.11-6.74-17a.33.33,0,0,0-.46,0,.32.32,0,0,0,0,.46c5,5.77,6.57,16.58,6.59,16.69A.32.32,0,0,0,372.51,329.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.53,329.11h0a.34.34,0,0,0,.33-.33c0-.11-.05-10.35,6-15.22a.33.33,0,1,0-.41-.51c-6.34,5.08-6.29,15.3-6.29,15.74A.34.34,0,0,0,375.53,329.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5,329h.08a.32.32,0,0,0,.23-.4,20.86,20.86,0,0,0-2.94-6.14.33.33,0,0,0-.46-.08.34.34,0,0,0-.07.46,20.25,20.25,0,0,1,2.84,5.93A.32.32,0,0,0,370.5,329Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52,324s.12-3.52-1.39-4-2.89.76-4,1.51-2.39,1.51-2.39,3.78a42.4,42.4,0,0,0,.88,6.41s1.26-3.9,3.4-5.66A8.8,8.8,0,0,1,368.52,324Z",
    style: {
      fill: "#30D6BE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.8,329.11a.34.34,0,0,0,.31-.23,11.39,11.39,0,0,1,3.28-4.87.33.33,0,1,0-.4-.52,12,12,0,0,0-3.5,5.19.32.32,0,0,0,.21.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.34,325.11a5.2,5.2,0,0,1,.75-3.9c1.26-1.63,4.28-1.26,5.79.5s3.65,7.05,3.65,7.05a12,12,0,0,0-6.54-2.39C379.46,326.37,379.34,325.11,379.34,325.11Z",
    style: {
      fill: "#30D6BE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.31 348.39 379.35 348.39 384.37 331.79 364.29 331.79 369.31 348.39",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.24,
    y: 329.03,
    width: 20.19,
    height: 2.75,
    transform: "translate(748.67 660.82) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.26,279.49a.94.94,0,0,1-.7-1.28l.05-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22.93.93,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.94.94,0,0,1-1.44-.28,12.13,12.13,0,0,1-1.19-2.35,13.26,13.26,0,0,1-1.22,2.35.94.94,0,0,1-1.44.28l-.1-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,382.26,279.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.4,279.49a.94.94,0,0,1-.7-1.28l.05-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66,1,1,0,0,1,1-1.06H396a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,11.57,11.57,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.94.94,0,0,1-1.44.28l-.1-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,392.4,279.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.54,279.49a1,1,0,0,1-.7-1.28l.05-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11,11,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.67,1.3,11.54,11.54,0,0,1-2.58.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.93.93,0,0,1-1.43.28l-.11-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,402.54,279.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M412.68,279.49a1,1,0,0,1-.7-1.28l0-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.67,1.3,11.54,11.54,0,0,1-2.58.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35A13.26,13.26,0,0,1,415,282.9a.93.93,0,0,1-1.43.28l-.11-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,412.68,279.49Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82,279.49a1,1,0,0,1-.7-1.28l.05-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.67,1.3,11.54,11.54,0,0,1-2.58.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.25,10.25,0,0,1,422.82,279.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M433,279.49a1,1,0,0,1-.7-1.28l.05-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,11.9,11.9,0,0,1,2.31-1.22.94.94,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.67,1.3,11.45,11.45,0,0,1-2.58.38,11.31,11.31,0,0,1,1.93,1.81,1,1,0,0,1-.17,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.25,10.25,0,0,1,433,279.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M443.11,279.49a1,1,0,0,1-.71-1.28l.05-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.66,11.9,11.9,0,0,1,2.31-1.22.94.94,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.68,1.3,11.45,11.45,0,0,1-2.58.38,11.31,11.31,0,0,1,1.93,1.81,1,1,0,0,1-.17,1.41l-.1.09a.94.94,0,0,1-1.44-.28,11.59,11.59,0,0,1-1.19-2.35,13.22,13.22,0,0,1-1.23,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.1,10.1,0,0,1,443.11,279.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M453.25,279.49a1,1,0,0,1-.71-1.28l0-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.66,11.9,11.9,0,0,1,2.31-1.22.94.94,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.68,1.3,11.45,11.45,0,0,1-2.58.38,11.31,11.31,0,0,1,1.93,1.81,1,1,0,0,1-.17,1.41l-.11.09a.93.93,0,0,1-1.43-.28,11.59,11.59,0,0,1-1.19-2.35,13.22,13.22,0,0,1-1.23,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.1,10.1,0,0,1,453.25,279.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.79,55a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.83,11.83,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66.94.94,0,0,1,1-1.05h.13a1,1,0,0,1,1,1.05,11,11,0,0,1-.44,2.66A12.47,12.47,0,0,1,189.27,53a.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.58.38,11,11,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,186.37,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.18,12.18,0,0,1,1.92-1.85A10.17,10.17,0,0,1,182.79,55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.93,55a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.55,11.55,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66.94.94,0,0,1,1-1.05h.13a.94.94,0,0,1,1,1.05,11,11,0,0,1-.44,2.66A12.47,12.47,0,0,1,199.41,53a.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.58.38,11,11,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,196.51,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.63,12.63,0,0,1,1.92-1.85A10.17,10.17,0,0,1,192.93,55Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.07,55a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.55,11.55,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66.94.94,0,0,1,1-1.05h.13a.94.94,0,0,1,1,1.05,11,11,0,0,1-.44,2.66A12.47,12.47,0,0,1,209.55,53a.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.58.38,11,11,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,206.65,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.63,12.63,0,0,1,1.92-1.85A10.17,10.17,0,0,1,203.07,55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.21,55a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.55,11.55,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66.94.94,0,0,1,1-1.05h.13a.94.94,0,0,1,1,1.05,11,11,0,0,1-.44,2.66A12.47,12.47,0,0,1,219.69,53a.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.58.38,11,11,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08A1,1,0,0,1,218,58.4,12,12,0,0,1,216.79,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.63,12.63,0,0,1,1.92-1.85A10.17,10.17,0,0,1,213.21,55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.35,55a.94.94,0,0,1-.71-1.27l.06-.14A.94.94,0,0,1,224,53a11.55,11.55,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66.94.94,0,0,1,1-1.05H227a.94.94,0,0,1,1,1.05,11.45,11.45,0,0,1-.43,2.66,12.12,12.12,0,0,1,2.3-1.22.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.58.38,11,11,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,226.93,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.28,12.28,0,0,1,1.93-1.85A10.18,10.18,0,0,1,223.35,55Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233.49,55a1,1,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.88,11.88,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66.94.94,0,0,1,1-1.05h.13a.94.94,0,0,1,1,1.05,11.45,11.45,0,0,1-.43,2.66A12.42,12.42,0,0,1,240,53a.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38A11.24,11.24,0,0,1,240,57.18a1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,237.07,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.28,12.28,0,0,1,1.93-1.85A10.18,10.18,0,0,1,233.49,55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M243.63,55a.93.93,0,0,1-.7-1.27l0-.14a.94.94,0,0,1,1.3-.57,11.88,11.88,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66,1,1,0,0,1,1-1.05h.13a.94.94,0,0,1,1,1.05,11.45,11.45,0,0,1-.43,2.66,12.42,12.42,0,0,1,2.3-1.22.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38,11.24,11.24,0,0,1,1.92,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,247.21,56,13.76,13.76,0,0,1,246,58.4a1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.28,12.28,0,0,1,1.93-1.85A10.18,10.18,0,0,1,243.63,55Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.77,55a.93.93,0,0,1-.7-1.27l.05-.14a.94.94,0,0,1,1.3-.57,11.88,11.88,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66.94.94,0,0,1,1-1.05h.13a.94.94,0,0,1,1,1.05,11.45,11.45,0,0,1-.43,2.66,12.42,12.42,0,0,1,2.3-1.22.94.94,0,0,1,1.3.6l0,.08a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38,11.24,11.24,0,0,1,1.92,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27A12,12,0,0,1,257.35,56a13.76,13.76,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.28,12.28,0,0,1,1.93-1.85A10.18,10.18,0,0,1,253.77,55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267.67,371.58a.94.94,0,0,1-.71-1.27l.05-.14a1,1,0,0,1,1.31-.57,11.83,11.83,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65.94.94,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.91,10.91,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.17,1.41l-.1.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36A13.35,13.35,0,0,1,270,375a.94.94,0,0,1-1.43.27l-.11-.08a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.07,10.07,0,0,1,267.67,371.58Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M277.81,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.83,11.83,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65.94.94,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.91,10.91,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.17,1.41l-.1.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36,13.39,13.39,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.07,10.07,0,0,1,277.81,371.58Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M288,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.83,11.83,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65.94.94,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.91,10.91,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.17,1.41l-.1.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36,13.39,13.39,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.14,10.14,0,0,1,288,371.58Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M298.09,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.83,11.83,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65.94.94,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.83,10.83,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36,13.39,13.39,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.62,12.62,0,0,1,1.92-1.84A10.14,10.14,0,0,1,298.09,371.58Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M308.23,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.83,11.83,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65,1,1,0,0,1,1-1.06h.13a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.83,10.83,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08A1,1,0,0,1,313,375a11.7,11.7,0,0,1-1.19-2.36,13.39,13.39,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.62,12.62,0,0,1,1.92-1.84A10.14,10.14,0,0,1,308.23,371.58Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M318.37,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.55,11.55,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65,1,1,0,0,1,1-1.06H322a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.83,10.83,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36,13.39,13.39,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,13.1,13.1,0,0,1,1.92-1.84A10.14,10.14,0,0,1,318.37,371.58Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M328.51,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.55,11.55,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65,1,1,0,0,1,1-1.06h.13a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65A12.47,12.47,0,0,1,335,369.6a.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.83,10.83,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36,13.39,13.39,0,0,1-1.22,2.36,1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.72,12.72,0,0,1,1.93-1.84A10.16,10.16,0,0,1,328.51,371.58Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M338.65,371.58a.94.94,0,0,1-.71-1.27l.06-.14a.94.94,0,0,1,1.3-.57,11.55,11.55,0,0,1,2.3,1.22,11.46,11.46,0,0,1-.43-2.65,1,1,0,0,1,1-1.06h.13a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.65,12.47,12.47,0,0,1,2.31-1.22.94.94,0,0,1,1.3.6l0,.08a.92.92,0,0,1-.68,1.3,10.83,10.83,0,0,1-2.58.38,11.75,11.75,0,0,1,1.93,1.82,1,1,0,0,1-.16,1.41l-.11.08a1,1,0,0,1-1.44-.27,11.7,11.7,0,0,1-1.19-2.36A13.39,13.39,0,0,1,341,375a1,1,0,0,1-1.44.27l-.11-.08a1,1,0,0,1-.16-1.41,12.72,12.72,0,0,1,1.93-1.84A10.16,10.16,0,0,1,338.65,371.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.4,322.38v-7.12a8.14,8.14,0,0,1,16.27,0v7.07h3.24v-7.07a11.38,11.38,0,0,0-22.75,0v7.12Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.96,
    y: 322.4,
    width: 24.83,
    height: 20.54,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,330.93a2.71,2.71,0,0,0-5.41,0,2.63,2.63,0,0,0,1.42,2.33l-.46,4.66H439l-.45-4.66A2.65,2.65,0,0,0,440,330.93Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.61,99V91.86a8.14,8.14,0,0,1,16.27,0v7.07h3.24V91.86a11.38,11.38,0,0,0-22.75,0V99Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.17,
    y: 99,
    width: 24.83,
    height: 20.54,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.17,107.53a2.71,2.71,0,0,0-5.41,0,2.63,2.63,0,0,0,1.42,2.33l-.46,4.67H87.2l-.45-4.67A2.65,2.65,0,0,0,88.17,107.53Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.62,45.17V40.5a5.34,5.34,0,0,1,10.67,0v4.64h2.13V40.5a7.46,7.46,0,0,0-14.92,0v4.67Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.71,
    y: 45.18,
    width: 16.29,
    height: 13.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55,50.78a1.78,1.78,0,0,0-3.55,0,1.72,1.72,0,0,0,.93,1.52l-.3,3.07h2.28l-.29-3.07A1.72,1.72,0,0,0,394.55,50.78Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-2--inject-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.17,
    y: 86.62,
    width: 318.28,
    height: 169.04,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 86.62,
    width: 262.81,
    height: 15.85,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.37,
    y: 86.62,
    width: 207.07,
    height: 15.85,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.9,
    y: 71.13,
    width: 318.54,
    height: 15.85,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.05,82.19H130.94a3.43,3.43,0,0,1-3.43-3.43h0a3.42,3.42,0,0,1,3.43-3.42H338.05a3.43,3.43,0,0,1,3.43,3.42h0A3.44,3.44,0,0,1,338.05,82.19Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.57,
    cy: 79.22,
    r: 2.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.46,79.22a2.89,2.89,0,1,0-2.88,2.88A2.88,2.88,0,0,0,415.46,79.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.58,
    cy: 79.22,
    r: 2.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.73 154.3 173.12 154.3 173.12 130.28 152.58 130.28 150.49 124.42 137.73 124.42 137.73 154.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.73 200.69 173.12 200.69 173.12 176.67 152.58 176.67 150.49 170.81 137.73 170.81 137.73 200.69",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.73 247.08 173.12 247.08 173.12 223.06 152.58 223.06 150.49 217.19 137.73 217.19 137.73 247.08",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.9 154.3 222.28 154.3 222.28 130.28 201.74 130.28 199.66 124.42 186.9 124.42 186.9 154.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.9 200.69 222.28 200.69 222.28 176.67 201.74 176.67 199.66 170.81 186.9 170.81 186.9 200.69",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.9 247.08 222.28 247.08 222.28 223.06 201.74 223.06 199.66 217.19 186.9 217.19 186.9 247.08",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.06 154.3 271.44 154.3 271.44 130.28 250.91 130.28 248.82 124.42 236.06 124.42 236.06 154.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.06 200.69 271.44 200.69 271.44 176.67 250.91 176.67 248.82 170.81 236.06 170.81 236.06 200.69",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.06 247.08 271.44 247.08 271.44 223.06 250.91 223.06 248.82 217.19 236.06 217.19 236.06 247.08",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.22 154.3 320.61 154.3 320.61 130.28 300.07 130.28 297.98 124.42 285.22 124.42 285.22 154.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.22 200.69 320.61 200.69 320.61 176.67 300.07 176.67 297.98 170.81 285.22 170.81 285.22 200.69",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.22 247.08 320.61 247.08 320.61 223.06 300.07 223.06 297.98 217.19 285.22 217.19 285.22 247.08",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.39 154.3 369.77 154.3 369.77 130.28 349.23 130.28 347.15 124.42 334.39 124.42 334.39 154.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.39 200.69 369.77 200.69 369.77 176.67 349.23 176.67 347.15 170.81 334.39 170.81 334.39 200.69",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.39 247.08 369.77 247.08 369.77 223.06 349.23 223.06 347.15 217.19 334.39 217.19 334.39 247.08",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.55 154.3 418.94 154.3 418.94 130.28 398.4 130.28 396.31 124.42 383.55 124.42 383.55 154.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.55 200.69 418.94 200.69 418.94 176.67 398.4 176.67 396.31 170.81 383.55 170.81 383.55 200.69",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.55 247.08 418.94 247.08 418.94 223.06 398.4 223.06 396.31 217.19 383.55 217.19 383.55 247.08",
    style: {
      fill: "#d9d9d9",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-1--inject-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.36,
    y: 120.01,
    width: 127.5,
    height: 112.5,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.56,
    y: 114.26,
    width: 127.5,
    height: 112.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.56,
    y: 114.26,
    width: 127.5,
    height: 8.04,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.34,162.44V150.58a8.13,8.13,0,0,1,16.26,0v6.93h3.24v-6.93a11.37,11.37,0,0,0-22.74,0v11.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.89,
    y: 161.28,
    width: 24.83,
    height: 20.54,
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.26,
    y1: 153.75,
    x2: 292.87,
    y2: 150.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.49,
    y1: 158.11,
    x2: 297.47,
    y2: 158.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.8,
    y1: 162.25,
    x2: 294.02,
    y2: 165.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,169.81a2.71,2.71,0,1,0-4,2.33l-.45,4.67h3.47l-.45-4.67A2.63,2.63,0,0,0,277.89,169.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.85,
    y: 190.19,
    width: 96.91,
    height: 17.49,
    rx: 4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.26,199.49a.94.94,0,0,1-.7-1.28l.05-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22.93.93,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.94.94,0,0,1-1.44-.28,12.13,12.13,0,0,1-1.19-2.35,13.26,13.26,0,0,1-1.22,2.35.94.94,0,0,1-1.44.28l-.1-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,236.26,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,199.49a.94.94,0,0,1-.7-1.28l.05-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11,11,0,0,1-.44-2.66,1,1,0,0,1,1-1.06H250a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.68,1.3,11.36,11.36,0,0,1-2.57.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,11.57,11.57,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.94.94,0,0,1-1.44.28l-.1-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,246.4,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,199.49a1,1,0,0,1-.7-1.28l0-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11,11,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.67,1.3,11.54,11.54,0,0,1-2.58.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.93.93,0,0,1-1.43.28l-.11-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,256.54,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.68,199.49a1,1,0,0,1-.7-1.28l0-.13a.94.94,0,0,1,1.3-.57,11.1,11.1,0,0,1,2.31,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.67,1.3,11.54,11.54,0,0,1-2.58.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35A13.26,13.26,0,0,1,269,202.9a.93.93,0,0,1-1.43.28l-.11-.09a1,1,0,0,1-.17-1.41,12.72,12.72,0,0,1,1.93-1.84A10.25,10.25,0,0,1,266.68,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.82,199.49a1,1,0,0,1-.7-1.28l.05-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,12.14,12.14,0,0,1,2.3-1.22,1,1,0,0,1,1.31.59l0,.09a.93.93,0,0,1-.67,1.3,11.54,11.54,0,0,1-2.58.38,10.86,10.86,0,0,1,1.92,1.81,1,1,0,0,1-.16,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.25,10.25,0,0,1,276.82,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,199.49a1,1,0,0,1-.7-1.28l.05-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11.45,11.45,0,0,1-.43,2.66,11.9,11.9,0,0,1,2.31-1.22.94.94,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.67,1.3,11.45,11.45,0,0,1-2.58.38,11.31,11.31,0,0,1,1.93,1.81,1,1,0,0,1-.17,1.41l-.11.09a.93.93,0,0,1-1.43-.28,12.1,12.1,0,0,1-1.2-2.35,13.26,13.26,0,0,1-1.22,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.25,10.25,0,0,1,287,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.11,199.49a1,1,0,0,1-.71-1.28l.05-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.66,11.9,11.9,0,0,1,2.31-1.22.94.94,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.68,1.3,11.45,11.45,0,0,1-2.58.38,11.31,11.31,0,0,1,1.93,1.81,1,1,0,0,1-.17,1.41l-.1.09a.94.94,0,0,1-1.44-.28,11.59,11.59,0,0,1-1.19-2.35,13.22,13.22,0,0,1-1.23,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.1,10.1,0,0,1,297.11,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,199.49a1,1,0,0,1-.71-1.28l0-.13a1,1,0,0,1,1.31-.57,11.3,11.3,0,0,1,2.3,1.22,11.45,11.45,0,0,1-.43-2.66,1,1,0,0,1,1-1.06h.14a1,1,0,0,1,1,1.06,11,11,0,0,1-.44,2.66,11.9,11.9,0,0,1,2.31-1.22.94.94,0,0,1,1.3.59l0,.09a.93.93,0,0,1-.68,1.3,11.45,11.45,0,0,1-2.58.38,11.31,11.31,0,0,1,1.93,1.81,1,1,0,0,1-.17,1.41l-.11.09a.93.93,0,0,1-1.43-.28,11.59,11.59,0,0,1-1.19-2.35,13.22,13.22,0,0,1-1.23,2.35.93.93,0,0,1-1.43.28l-.11-.09a.94.94,0,0,1-.16-1.41,12.16,12.16,0,0,1,1.92-1.84A10.1,10.1,0,0,1,307.25,199.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.35,454.5h3.45a.89.89,0,0,0,.89-.84l2.74-28.54h-10.7l2.73,28.54A.9.9,0,0,0,148.35,454.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,454.5h3.45a.9.9,0,0,0,.89-.84l2.73-28.54h-10.7l2.74,28.54A.89.89,0,0,0,115,454.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,454.5h3.45a.89.89,0,0,0,.89-.84l2.74-28.54h-10.7l2.73,28.54A.9.9,0,0,0,169.35,454.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,454.5h3.45a.9.9,0,0,0,.89-.84l2.73-28.54h-10.7l2.74,28.54A.89.89,0,0,0,204,454.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.56,426.29h68.52s7-23.4,12.46-46,11.68-51,5.06-56.85-24.14,4.29-37.38,7-16-.39-24.91-9.73-16.74-24.53-31.93-34.26-26.47-11.29-37-4.67a36.27,36.27,0,0,0-11.3,24.13c-.77,15.19,3.51,34.27,9,44.78S153.56,426.29,153.56,426.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,383.45h74s13.33-13.33,15.33-45.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,254.05l-8.38,5.12s5.82,31.89,4.43,48.65-8.38,32.82-8.38,32.82H205.9s8.38-20,12.11-34-2.79-46.79-2.79-46.79Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.56,339.05s4.81-1.53,6.1-1.52,5.48,3.29,5.48,3.29.17,1.2-.78,1.45-4.2-2-4.2-2l-5.41,1.6Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.08,336a40.71,40.71,0,0,1,6.15,1.35c1.15.57,3.45,5.37,3.45,5.37s-.38,1.15-1.34,1-2.88-3.65-2.88-3.65l-5.57-1Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,334.45l6.34,1.54,4,2.69,2.3,5.56a2.12,2.12,0,0,1-1.73.58c-1-.19-5-4.61-5-4.61L284,336.56l-1.92-2.11Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,332.73s9.79.38,11.9.38,7.68,4.41,8.64,4.8,5,6.14,5,6.14.19,0-1.15.39-3.46-1-3.46-1l-2.68-3.27-6.53-1.15s4.8,2.5,5.95,2.88,1.92,1.73,1.54,2.5-6.18-1.72-6.18-1.72a5.22,5.22,0,0,1-4.47,0c-2.31-1.15-2.61-1.18-5.05-2.31s-7.34-4-7.34-4Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.1,264.29s3.73.7,4.66,2.79,7,49.59,7,49.59l40,14.62-.77,14s-47.37-5.81-50.63-5.11-11.18,1.63-14.44-.94S215,326,217.26,316.12c5.34-23.33,4.67-39.33,4.67-39.33S215.45,261.5,220.1,264.29Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,291.52s-5.82,23.28-8.38,29.57-7.69,16.76-7.69,16.76l-5.58.93s11.64-25.14,13.73-35.15-2.56-35.38-2.79-36.31,1.63-6.75,5.12-5.59",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.75 285.01 208 302 200.78 283.84 209.4 277.09 214.75 285.01",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.38 271.27 218.94 291.06 208 282.68 216.38 271.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,236.07s-.24,13.14-1.31,15-3.33,4.63-3.43,7.14,2.9,7.93,1.1,9.67a4.41,4.41,0,0,1-4.27.89s-5.85,7-9.12,8.62-12-3-12-3l-8.71,9-16.06-29.1,9.2-6.19s3.55-18.29,14.94-22.14S245.1,231.46,246.88,236.07Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,252.63s-3.52,7.35-.5,12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.25,254.85c-.44,1-.42,2,.05,2.18s1.21-.43,1.65-1.43.43-2,0-2.18S237.7,253.85,237.25,254.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.11,269.33s-3.52-.71-3.52-3.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.87,
    y1: 255.73,
    x2: 237.45,
    y2: 258.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,251s-.13-3.45-5.72-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,226.23c-2.46.27-4.91,2.18-5.73.54s-.27-7.64-4.37-8.18-3.82,1.36-5.18,1.64-3-6-8.18-5.19-8.44,3-8.73,4.08c-8.94-.07-14.44,3.57-18.38,10.87-4.33,8-1.68,18.1-1.68,18.1s-4.08,3.16-.82,4.09,13.32.45,13.32.45l-1.06-.47c-1.07-.47-2.79-4,.73-9.1s5.91-.69,6.22,1.49.49,4,1.77,4.61,2.15-.83,2.48-2.72,4.18-2,7-3.24.15-3.75-2.22-7.61,3.64-4.75,9.22-1.25c3.22,2,4.9,3.1,6.49,3.3l.08.05s2.72,2.18,4.91.27,3.54-2.18,5.45-4.37S257,226,254.55,226.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,252.65l15.37,29.8-9.78,10.24s-8.38-22.58-9.31-28.17-1.63-9.54-1.63-9.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,336.79s45-2.34,50.67,0,7,8.33,6.33,14.33-4,41.33-5.33,51.33-2,22.34-1,24.67,4,6.33,3,8.67-2.67,3.33-2.67,4.33a6.41,6.41,0,0,0,1.33,2.67s12.34,5.33,16.67,7,4.67,3,3.67,3.66-21.67,0-25.34,0-10.66-2.33-10.66-2.33v1.67h-9v-6.34a54.53,54.53,0,0,1,.33-6s-1.67-4.33-1.33-6,2.33-5.33,3-8.66,0-8-.34-11.67a28.33,28.33,0,0,1,.34-8c.33-2-2-38.33-2-38.33s-26.34,8-29,8.33-24.34,8.33-33.34,6,3.67-30.67,13.67-40.33S202.93,336.79,202.93,336.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,333.45s29.66,2.34,33,5.67,2.33,10,2.33,14.33-4,62-4.33,65.34,3.33,6.66,2,9a15.22,15.22,0,0,0-2,6c0,1,9,8.33,12.66,10.33s14,4.33,15.67,6,1.33,3-1.67,4-28,0-28,0-3.66,0-5-1a9.09,9.09,0,0,0-2.33-1.33L206.6,454h-13a94,94,0,0,1-1.34-10.9,54,54,0,0,1,1-8.33,10.42,10.42,0,0,1-1.66-6c.33-3,2.66-4.34,2.66-6.34s-2-8-1.66-11.66.66-8,.66-8l-3-29.34s-20,11-29.66,10-12.34-2.33-15-7-2.67-24.33,1.66-32S175.6,329.79,184.6,333.45Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.68,255s7,17.46,7.68,27.93-.23,34.92-2.79,41.9-3.73,11.41-3.73,11.41-23.27,3.49-26.3,4.65-9.31,10.25-10.48,17.93c-.33,2.21-.57,4.6-.74,6.88a56.89,56.89,0,0,0,1.17,15.56c.19,1,.23,1.76-.06,2.05-.93.93-13.4-4.71-17.59-19.14s-2.1-31.42,1.63-39.34,18.15-55.17,24.44-61.45S188.68,255,188.68,255Z",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,338.84s8.8,1.14,11.07,1.71a7.69,7.69,0,0,1,3.8,2.63l-.85.79-6.36-2.41Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,340.24s5.37.33,6,1,3.51,5.48,3.51,5.48l-1.31.88-3.62-3.4L271,341.67Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.16,338.26s10,.85,11.95,2,4.5,6.25,4.5,6.25l-1.42.56-4.82-4.82-11.91-2Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.72,343.31s2.75,1.43,4.17,1.43,5.92-1.54,5.92-1.54a53.92,53.92,0,0,0-5.37-2C264.56,341.12,260.72,343.31,260.72,343.31Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,333.72s11.91,2.84,13.33,3.69,8.23,4.25,9.08,4.82,3.41,5.11,3.41,5.11-1.71,2-2.27.56a19.23,19.23,0,0,0-3.12-4l-5.11-1.7a15.09,15.09,0,0,1-6,1.42c-3.12,0-6.48-3.08-6.48-3.08L246.12,342Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.46,267.24s7.07,6.17,7.65,13.13.5,9.76.55,10.93,4.2,31.74,4.2,31.74l59.43,9.63-1.14,13.2-67.72-1.3s-4.62.93-7.12-2.44-17-54.48-17-54.48",
    style: {
      fill: "#30D6BE",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21,327.69a12.13,12.13,0,0,0-1.79,1.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,324.07a18.47,18.47,0,0,0-8.41,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,326.61s-5.73,1.92-6.92,5.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.56,426.29s-1.17-41.7-11.68-69-16.74-30.76-21-29.59-10.51,8.56-14.4,3.5-9.73-19.08-7.4-31.54,7-14.79,9.35-17.9-10.13,4.28-15.58,12.45-5.45,28-2.33,48.67,10.9,79.08,13.62,81.41,9.35,2.34,9.35,2.34h35.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.31,
    y: 344.55,
    width: 91.5,
    height: 4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.49,
    y: 344.55,
    width: 44.32,
    height: 4,
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.56 308.79 316.24 308.79 303.49 344.54 347.81 344.54 360.56 308.79",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.07,351h.63a2.59,2.59,0,0,1,2.59,2.59v101a0,0,0,0,1,0,0h-5.8a0,0,0,0,1,0,0v-101A2.59,2.59,0,0,1,314.07,351Z",
    transform: "translate(628.76 805.58) rotate(180)",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.62,351h.63a2.59,2.59,0,0,1,2.59,2.59v101a0,0,0,0,1,0,0H322a0,0,0,0,1,0,0v-101A2.59,2.59,0,0,1,324.62,351Z",
    transform: "translate(649.86 805.58) rotate(180)",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,351h.63a2.59,2.59,0,0,1,2.59,2.59v101a0,0,0,0,1,0,0h-5.8a0,0,0,0,1,0,0v-101A2.59,2.59,0,0,1,242.52,351Z",
    transform: "translate(485.67 805.58) rotate(180)",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,351h.63a2.59,2.59,0,0,1,2.59,2.59v101a0,0,0,0,1,0,0h-5.8a0,0,0,0,1,0,0v-101A2.59,2.59,0,0,1,387,351Z",
    transform: "translate(774.6 805.58) rotate(-180)",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.17,
    y: 348.66,
    width: 162.49,
    height: 4.72,
    transform: "translate(628.84 702.04) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.17,
    y: 398.7,
    width: 162.49,
    height: 4.72,
    transform: "translate(628.84 802.11) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.15,
    y: 393.88,
    width: 42.43,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.53,
    y: 393.88,
    width: 19.06,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.57,
    y: 393.88,
    width: 42.43,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.95,
    y: 393.88,
    width: 19.06,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.65,
    y: 388.93,
    width: 42.43,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.02,
    y: 388.93,
    width: 19.06,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37.3,
    y1: 454.56,
    x2: 475.3,
    y2: 454.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureloginBro);
export default __webpack_public_path__ + "static/media/Secure login-bro.312d33532a43b31b08e95fb4559bdb95.svg";
export { ForwardRef as ReactComponent };